import FrontendDeveloperPage from "./FrontendDeveloperPage";

export default function ShopifyDeveloperPage() {
  return <FrontendDeveloperPage technology="shopify" />;
}
